export const FETCH_STORES_REQUEST = 'FETCH_STORES_REQUEST';
export const FETCH_STORES_SUCCESS = 'FETCH_STORES_SUCCESS';
export const FETCH_STORES_FAILURE = 'FETCH_STORES_FAILURE';

export const FETCH_STORE_STATS_REQUEST = 'FETCH_STORE_STATS_REQUEST';
export const FETCH_STORE_STATS_SUCCESS = 'FETCH_STORE_STATS_SUCCESS';
export const FETCH_STORE_STATS_FAILURE = 'FETCH_STORE_STATS_FAILURE';

export const FETCH_STORE_GROUPS_REQUEST = 'FETCH_STORE_GROUPS_REQUEST';
export const FETCH_STORE_GROUPS_SUCCESS = 'FETCH_STORE_GROUPS_SUCCESS';
export const FETCH_STORE_GROUPS_FAILURE = 'FETCH_STORE_GROUPS_FAILURE';

export const CREATE_STORE_GROUP_REQUEST = 'CREATE_STORE_GROUP_REQUEST';
export const CREATE_STORE_GROUP_SUCCESS = 'CREATE_STORE_GROUP_SUCCESS';
export const CREATE_STORE_GROUP_FAILURE = 'CREATE_STORE_GROUP_FAILURE';

export const CREATE_STORE_REQUEST = 'CREATE_STORE_REQUEST';
export const CREATE_STORE_SUCCESS = 'CREATE_STORE_SUCCESS';
export const CREATE_STORE_FAILURE = 'CREATE_STORE_FAILURE';

export const UPDATE_STORE_REQUEST = 'UPDATE_STORE_REQUEST';
export const UPDATE_STORE_SUCCESS = 'UPDATE_STORE_SUCCESS';
export const UPDATE_STORE_FAILURE = 'UPDATE_STORE_FAILURE';

export const DELETE_STORE_REQUEST = 'DELETE_STORE_REQUEST';
export const DELETE_STORE_SUCCESS = 'DELETE_STORE_SUCCESS';
export const DELETE_STORE_FAILURE = 'DELETE_STORE_FAILURE';
